import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import AcaoButtons from "../../Shared/AcaoButtons";

const STATUS_FINALIZACAO_OPTIONS = [
    { value: "RESOLVIDO", label: "Resolvido" },
    { value: "NAO_RESOLVIDO", label: "Não Resolvido" },
];

// Etapa "Análise da TI" — registra a solução aplicada e conclui o chamado numa única ação (o
// resultado já está expresso no status de finalização, não numa escolha separada de Aprovar/Reprovar).
export default function EtapaChamadoTIAnalise({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [solucaoAplicada, setSolucaoAplicada] = useState("");
    const [statusFinalizacao, setStatusFinalizacao] = useState(null);

    const valido = solucaoAplicada.trim() && statusFinalizacao;

    function executar(acao) {
        if (!valido) return;
        onExecutarAcao(acao, { dados: { solucaoAplicada, statusFinalizacao } });
    }

    return (
        <div className="flex flex-col gap-4">
            <Textarea label="Solução aplicada" required value={solucaoAplicada} onChange={e => setSolucaoAplicada(e.target.value)} rows={4}
                placeholder="Descreva a solução aplicada ao chamado..." />

            <div>
                <label className="text-sm font-medium text-foreground/80 block mb-1.5">
                    Status de finalização <span className="text-destructive">*</span>
                </label>
                <CustomDropdown value={statusFinalizacao} onChange={e => setStatusFinalizacao(e.value)} options={STATUS_FINALIZACAO_OPTIONS} placeholder="Selecione" />
            </div>

            <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} disabled={!valido} />
        </div>
    );
}
